import { render, staticRenderFns } from "./GateImpacts.vue?vue&type=template&id=566ef758&scoped=true"
import script from "./GateImpacts.vue?vue&type=script&lang=ts"
export * from "./GateImpacts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566ef758",
  null
  
)

export default component.exports